import React from 'react';
import {observer} from 'mobx-react';
import BackToIndex from 'shared/components/navigation/BackToIndex';
import SubNav from 'shared/components/navigation/SubNav';
import DocumentTitle from 'shared/components/DocumentTitle';

const Display = observer(({backTitle, backPath, back, title, toolbar, children, documentTitle, nested, onBackClick}) => {
  const _back = back || !!backTitle || !!backPath || !!onBackClick;
  const docTitle = documentTitle || title;

  return (
    <div className='print-hide'>
      {!!docTitle && <DocumentTitle title={docTitle}/>}
      {_back && <BackToIndex nested={nested} title={backTitle} path={backPath} hasTitle={!!title} onBackClick={onBackClick}/>}
      {!!title && <SubNav title={title} className={_back ? '' : 'pt1'} toolbar={toolbar}>{children}</SubNav>}
    </div>
  );
});

export default Display;
